
/**
 * Helper
 */
var helper = require('../../helper');

/**
 * Other necessary controllers
 */
var ToastrController = new (require('../../services/ToastrController'));

function EditRoomController($modal) {
    this.$modal                 = $modal;
    var self                    = this;
}

EditRoomController.prototype.getRoom = function(roomId, callback) {

    $.ajax({
        type: 'POST',
        url: helper.getOrigin() + "/api/rooms/get",
        data: { 'id' : roomId },
        dataType: 'json',

        success: function(data) {
            var roomObject = data.room;
            callback(roomObject);
        },

        error: function (data) {
            console.log('Error with getRoom()');
        }
    });
}

EditRoomController.prototype.updateRoom = function(fields, callbackSuccess, callbackErrors) {
    $.ajax({
        type: 'POST',
        url: helper.getOrigin() + "/api/rooms/update",
        data: fields,
        dataType: 'json',

        success: function(data) {
            var room = null;
            if (data.status == 'error') {
                ToastrController.showDanger(data.message);
            } else {
                ToastrController.showSuccess(data.message);
                room = data.room;
            }
            callbackSuccess(room);
        },

        error: function(data) {
            var errors = data.responseJSON;
            callbackErrors(errors);
        }
    });
}

module.exports = EditRoomController;